import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import styles from './CookieConsent.module.css';

const STORAGE_KEY = 'cookieConsent';

const CookieConsent = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Spacer: fixed banner'ın kapladığı alan kadar sayfa akışında boşluk */}
      <div className={styles.spacer} />
      <div className={styles.overlay}>
        <div className={styles.banner}>
          <div className={styles.content}>
            <p className={styles.text}>
              {t('cookie.message')}{' '}
              <Link to="/gizlilik-politikasi" className={styles.link}>{t('cookie.privacyLink')}</Link>{' '}
              {t('cookie.reviewText')}
            </p>
            <div className={styles.buttons}>
              <button className={styles.acceptBtn} onClick={handleAccept}>
                {t('cookie.accept')}
              </button>
              <button className={styles.rejectBtn} onClick={handleReject}>
                {t('cookie.reject')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
